export default __webpack_public_path__ + "static/media/height-snow.6a4c3b03.png";